import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import CustomersPage from "@/pages/Customers";
import InvoicesPage from "@/pages/Invoices";
import AgentPage from "@/pages/Agent";
import CommunicationsPage from "@/pages/Communications";
import SettingsPage from "@/pages/Settings";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/agent" element={<AgentPage />} />
        <Route path="/communications" element={<CommunicationsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
